/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_TaglineInputs */

const en_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You on the mic, from one photo`)
};

const es_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú en el micrófono, con una sola foto`)
};

/**
* | output |
* | --- |
* | "You on the mic, from one photo" |
*
* @param {Footer_TaglineInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_tagline = /** @type {((inputs?: Footer_TaglineInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_TaglineInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_tagline(inputs)
	return es_footer_tagline(inputs)
});